<script lang="ts">
	import { getProductsCategoryPath } from "../../../core/schema/paths/getProductsCategoryPath.js";
	import type { Category } from "../../../core/schema/Category.js";
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { productsPathMap } from "../../../core/schema/paths/productsPathMap.js";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { productsAnchorPathMap } from "../../../core/schema/paths/productsAnchorPathMap.js";

	export let category: Category | undefined;
	export let customHref: string | undefined = undefined;
	export let selected: string | undefined;
	export let largeIndex: number | undefined = undefined;
	export let productCount = 0;

	const { TENANT_LOCALE } = getGlobalSettings();

	function handleFilterSelect(): void {
		if (category === undefined) {
			selected = "";
			return;
		}
		selected = selected === category.id ? "" : category.id;
	}

	let isFirstInRowMd: boolean;
	let isFirstInRowXl: boolean;
	let borderLeftClass: string;
	$: if (largeIndex !== undefined) {
		isFirstInRowMd = largeIndex % 2 === 1;
		isFirstInRowXl = largeIndex % 4 === 1;

		borderLeftClass = `
		${isFirstInRowMd ? "md:border-l" : "md:border-l-0"}
		${isFirstInRowXl ? "xl:border-l" : "xl:border-l-0"}
	`.trim();
	}

	$: isSelected = (category === undefined && selected === "") || (category !== undefined && selected === category.id);
	$: filterPath = customHref
		? customHref
		: category === undefined || isSelected
			? `/${productsPathMap[TENANT_LOCALE]}${productsAnchorPathMap[TENANT_LOCALE]}`
			: `/${getProductsCategoryPath(category, TENANT_LOCALE)}#produkty`;
</script>

<div>
	{#if largeIndex}
		<a href={filterPath} class="group hidden w-full flex-col md:flex">
			<span
				class="font-quicksand group-hover:text-tertiary w-12 text-[4.375rem] leading-none {isSelected
					? 'text-tertiary'
					: 'text-gray'}">{largeIndex}</span
			>
			<span
				class="text-md border-gray group-hover:text-tertiary group-hover:bg-mint w-full border text-center sm:w-[21.25rem] {borderLeftClass} py-6 font-extrabold {isSelected &&
					'text-tertiary bg-mint'}"
			>
				{nbspify(category === undefined ? "Všechny kategorie" : category.name)}</span
			>
		</a>
		<a
			href={filterPath}
			class="text-2xs text-bito-black border-gray text-nowrap border px-4 py-1 font-bold md:hidden {isSelected &&
				'border-tertiary text-tertiary bg-mint'}"
		>
			{nbspify(category === undefined ? "Všechny kategorie" : category.name)}</a
		>
	{:else}
		<a
			href={filterPath}
			class="text-2xs text-bito-black border-gray text-nowrap border px-4 py-1 font-bold {isSelected &&
				'border-tertiary text-tertiary bg-mint'}"
			on:click={handleFilterSelect}
		>
			{nbspify(category === undefined ? "Všechny kategorie" : category.name)} – {productCount}</a
		>
	{/if}
</div>
